import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'clv-clv-angular-pipes-utilities',
  template: `
    <p>
      clv-angular-pipes-utilities works!
    </p>
  `,
  styles: []
})
export class ClvAngularPipesUtilitiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
